<template>
    <div>
    <div v-if="modal" class="modal-overlay" :style="{ opacity: overlay }" @click="handleClose"></div>
        <transition name="fade" appear>
            <AppBoxContent class="modal" v-if="modal" width="lg" :useMinHeight="useMinHeight">
                <div class="absolute top-0 right-0 p-4" v-if="!lockCloseModal">
                    <button @click="handleClose">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-6 h-6"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div :class="['md:h-full', { 'mt-7': useMarginTop }]">
                    <slot />
                </div>
            </AppBoxContent>
        </transition>
    </div>
</template>

<script>
import AppBoxContent from "./AppBoxContent";

export default {
    components: {
        AppBoxContent,
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        close: {
            type: Function,
            default: () => {},
        },
        useMinHeight: {
            type: Boolean,
            default: true,
        },
        lockCloseModal: {
            type: Boolean,
            default: false,
        },
        overlay: {
            type: Number,
            default: 0.6,
        },
        useMarginTop: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            modal: this.showModal,
        };
    },

    watch: {
        showModal(value) {
            this.modal = value;
        },
    },

    mounted() {
        window.addEventListener("keydown", this.handleKeydown);
    },

    beforeDestroy() {
        window.removeEventListener("keydown", this.handleKeydown);
    },

    methods: {
        handleClose() {
            this.$emit("close");
            if (!this.lockCloseModal) {
                this.modal = false;
            }
        },

        handleKeydown(event) {
            if (event.key === "Escape" && this.modal) {
                this.handleClose();
            }
        },
    },
};
</script>

<style scoped>
.modal {
    position: absolute;
    /* position: fixed; */
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    text-align: center;
    height: fit-content;
    padding: 2rem;
    border-radius: 1rem;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
    background: #fff;
    z-index: 999;
    transform: none;
}
.modal h1 {
    margin: 0 0 1rem;
}

.modal-overlay {
    content: "";
    position: absolute;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 998;
    background: #2c3e50;
    cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
    transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
    opacity: 0;
    transform: scale(0.3) translateY(-50%);
}
</style>
